import { Guardian } from '@xaamin/guardian';

Guardian.define('modulos_adicionales.access', (user) => {
  return user.cliente?.servicios?.modulos_adicionales === true;
});

Guardian.define('autofacturacion.access', (user) => {
  return user.cliente?.servicios?.autofacturacion === true;
});

Guardian.define('facturacion_masiva.access', (user) => {
  return !!user.cliente?.servicios?.facturacion_masiva === true;
});

Guardian.define('cancelacion_masiva.access', (user) => {
  return !!user.cliente?.servicios?.cancelacion_masiva === true;
});

Guardian.define('retenciones.access', (user) => {
  return (
    user.cliente?.servicios?.cliente_externo !== true &&
    user.cliente?.servicios?.retenciones === true &&
    user.can('retencion.listar')
  );
});

Guardian.define('retencion_masiva.access', (user) => {
  return !!user.cliente?.servicios?.retencion_masiva === true;
});

Guardian.define('receptores.access', (user) => {
  return user.cliente?.servicios?.cliente_externo !== true;
});

Guardian.define('developers.access', (user) => {
  return user.cliente?.servicios?.cliente_externo !== true;
});

Guardian.define('reportes.hits.access', (user) => {
  return user.cliente?.servicios?.cliente_externo !== true;
});

Guardian.define('timbrado_sftp.access', (user) => {
  return user.cliente?.servicios?.timbrado_sftp === true;
});

Guardian.define('socios_de_negocio.access', (user) => {
  return user.cliente?.servicios?.socios_de_negocio === true;
});

Guardian.define('catalogo_cliente.access', (user) => {
  return !!user.cliente?.servicios?.catalogo_cliente === true;
});

Guardian.define('portal_receptores.access', (user) => {
  return !!user.cliente?.servicios?.portal_receptores === true;
});

Guardian.define('administrar_pagos.access', (user) => {
  return !!user.cliente?.servicios?.administrar_pagos === true;
});

Guardian.define('factoraje_financiero.access', (user) => {
  return !!user.cliente?.config?.factoraje_financiero === true;
});

Guardian.define('representacion_impresa.access', (user) => {
  return !!user.cliente?.config?.pdf_sucursal === true;
});

Guardian.define('excel_conceptos.access', (user) => {
  return !!user.cliente?.servicios?.excel_conceptos === true;
});

Guardian.define('excel_cartaporte.access', (user) => {
  return !!user.cliente?.servicios?.excel_cartaporte === true;
});

Guardian.define('excel_comercioexterior.access', (user) => {
  return !!user.cliente?.servicios?.excel_comercioexterior === true;
});

Guardian.define('prefacturas.access', (user) => {
  return user.cliente?.servicios?.prefacturas === true;
});

Guardian.define('factura_observaciones.access', (user) => {
  return user.cliente?.servicios?.factura_observaciones === true;
});

Guardian.define('claveprodserv_requerido.access', (user) => {
  return user.cliente?.servicios?.claveprodserv_requerido === true;
});

Guardian.define('recepcion.access', (user) => {
  return user.cliente?.servicios?.recepcion === true;
});

Guardian.define('sector_primario.access', (user) => {
  return user.cliente?.servicios?.sector_primario === true;
});
